/* global globalThis */

// config.js

export const USDI_API_URL = 'https://usdi-api-jlukzyz7wa-ew.a.run.app/';
export const APP_URL = "https://app.prismax.ai/";
export const PRISMAX_BACKEND_URL = 'https://app-prismax-backend-1053158761087.us-west2.run.app';

export const PRISMAX_BACKEND_Control_URL = 'https://app-prismax-teleop-backend-1053158761087.us-west2.run.app';

// export const RPC_URL2 = 'https://solitary-boldest-thunder.solana-mainnet.quiknode.pro/7e14722814e9fc29ad81532c2da66c2ffbe3781f';
// export const RPC_URL3 = "https://rpc.ankr.com/solana/80465c767c6a5751c4cadf0778b6917d26c2d0a9ae583d3616ffaae71191a7c4";
//export const RPC_URL = "https://mainnet.helius-rpc.com/?api-key=87eb0292-8ed2-4c97-94a3-2a325517875b"
export const RPC_URL = "https://mainnet.helius-rpc.com/?api-key=c58d0d16-a456-466f-83cd-ad43b23414d0"

//export const RPC_URL = 'https://rpc.ankr.com/multichain/cd6af10201a606f9c2a94c8b1a21482cb90809b9fa276a3a819fc731bd938f3a'


/**
 * Returns the number of times the current page / Node process
 * has called the configured Solana RPC endpoint.
 */
let _rpcCallCount = 0;


export function getRpcCallCount() {
  return _rpcCallCount;
}


export function flushRpcCallCount(reset = false) {
  const n = _rpcCallCount;
  if (reset) _rpcCallCount = 0;
  return n;
}


if (typeof globalThis.fetch === 'function' && !globalThis.__rpcWrapped) {
  const originalFetch = globalThis.fetch.bind(globalThis);

  globalThis.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input?.url;

    if (url && url.startsWith(RPC_URL)) {
      _rpcCallCount += 1;

      if (process.env.NODE_ENV !== 'production') {
        const stackLines = (new Error().stack || '')
          .split('\n')          // each frame
          .slice(2, 8)           // skip Error + wrapper; keep next ~6 frames
          .map(l => l.trim());   // tidy

        console.log(
          `\n[RPC] call #${_rpcCallCount}: ${url}` +
          (stackLines.length ? `\n↳ Trace:\n  ${stackLines.join('\n  ')}` : '')
        );
      }
    }

    return originalFetch(input, init);
  };

  globalThis.__rpcWrapped = true;
}




let configCache = {
    usdtTokenAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    usdcTokenAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    prismaxRecevingAddress: '',
    isFetched: false, // We'll rely on this to see if we need to fetch
};

// This function does the actual fetching:
async function initConfig() {
    try {
        {
            const res = await fetch(`${PRISMAX_BACKEND_URL}/get_blockchain_config_address`);
            if (!res.ok) throw new Error('Failed to fetch verified_solana_token_mint_address');
            const data = await res.json();
            if (data) {
                if (data.verified_token_solana_usdt) {
                    configCache.usdtTokenAddress = data.verified_token_solana_usdt;
                }
                if (data.verified_token_solana_usdc) {
                    configCache.usdcTokenAddress = data.verified_token_solana_usdc;
                }
                if (data.prismax_receiving_address) {
                    configCache.prismaxRecevingAddress = data.prismax_receiving_address;
                }
            }
        }


        configCache.isFetched = true;

    } catch (error) {
        console.error('Error fetching config:', error);
        throw error;
    }
}

/**
 * getConfig: Lazy-loads the config if it hasn't been fetched yet.
 */
export async function getConfig() {
    if (!configCache.isFetched) {
        await initConfig();
    }

    // Return a snapshot of the config
    return {
        usdtTokenAddress: configCache.usdtTokenAddress,
        usdcTokenAddress: configCache.usdcTokenAddress,
        prismaxRecevingAddress: configCache.prismaxRecevingAddress,
    };
}
